import React from "react";
import { Route, Routes } from "react-router-dom";
import { useAuthorization } from "@common/providers";
import { useV2WhoAmIQuery } from "@generated";
import ScopeStackSpinner from "@components/ScopeStackSpinner/ScopeStackSpinner";
import { Show } from "./Show";
import { New } from "./New";
import { Edit } from "./Edit";
import { Unauthorized } from "./Unauthorized";

const ReleaseFlagsMspa: React.FC = () => {
  const authorized = useAuthorization();
  const { data: currentUser, isLoading } = useV2WhoAmIQuery();

  if (!authorized || isLoading || !currentUser) {
    return <ScopeStackSpinner />;
  }

  const isSiteAdmin = Boolean(currentUser?.data?.attributes?.["site-admin"]);
  if (!isSiteAdmin) {
    return <Unauthorized />;
  }

  return (
    <Routes>
      <Route path="/" element={<Show />} />
      <Route path="/new" element={<New />} />
      <Route path="/:releaseFlagId/edit" element={<Edit />} />
    </Routes>
  );
};

export default ReleaseFlagsMspa;
